<template>
  <div class="container">
    <h2 class="text-center">{{ title }}</h2>
    <div class="row">
      <div class="col-xl-3 col-lg-12">
        <address>
        <h3>Омский офис</h3>
        <strong>Адрес:</strong>
        <br>Россия, 644043
        <br>г. Омск
        <br>ул. Певцова 7, этаж 3
        <br><strong>Телефоны:</strong>
        <br>(3812) 21-00-42, 24-54-12, 24-63-16
        <br>Проезд до остановки «Кинотеатр им. Маяковского»
        </address>
      </div>
      <div class="col-xl-9 col-lg-12">
        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1872.2718696053757!2d73.36050530164741!3d54.990549667862766!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x43aafe1e4d0e1e83%3A0x6af2c6ee26af13e!2z0YPQuy4g0J_QtdCy0YbQvtCy0LAsIDcsINCe0LzRgdC6LCDQntC80YHQutCw0Y8g0L7QsdC7LiwgNjQ0MDQz!5e0!3m2!1sru!2sru!4v1526559608071" width="100%" height="600" frameborder="0" style="border:0" allowfullscreen></iframe>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        message: '',
        title: 'Контакты'
      }
    }
  }
</script>

<style scoped>
  .container {
    margin-top: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/parts/Contacts.vue